import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../component/layout';

import PurchaseOrderTab from './purchase_orders';
import GoodsReceivedNotesTab from './goodsReceivedNotesTab';
import PurchaseOrderInvoiceTab from './purchaseOrderInvoiceTab';

function PurchaseOrderManagement() {
    const [activeTab, setActiveTab] = useState('purchase-orders');
    
    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/inventory_management"}>
                                        Inventory Management
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    Purchase Order Management
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-body py-0">
                                                    <ul className="nav nav-tabs profile-tabs">
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTab === 'purchase-orders' ? 'active' : ''}`}
                                                                onClick={() => setActiveTab('purchase-orders')}
                                                                type="button"
                                                            >
                                                                <i className="ti ti-shopping-cart me-2"></i>Purchase Orders
                                                            </button>
                                                        </li>
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTab === 'goods-received' ? 'active' : ''}`}
                                                                onClick={() => setActiveTab('goods-received')}
                                                                type="button"
                                                            >
                                                                <i className="ti ti-truck-delivery me-2"></i>Goods Received Notes
                                                            </button>
                                                        </li>
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTab === 'purchase-invoices' ? 'active' : ''}`}
                                                                onClick={() => setActiveTab('purchase-invoices')}
                                                                type="button"
                                                            >
                                                                <i className="ti ti-file-invoice me-2"></i>Purchase Order Invoices
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div className="tab-content" style={{ paddingTop: '1rem' }}>
                                                {activeTab === 'purchase-orders' && (
                                                    <PurchaseOrderTab />
                                                )}
                                                {activeTab === 'goods-received' && (
                                                    <GoodsReceivedNotesTab />
                                                )}
                                                {activeTab === 'purchase-invoices' && (
                                                    <PurchaseOrderInvoiceTab />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default PurchaseOrderManagement;